import { type PropsWithChildren } from "react"
import { Typography, type TypographyProps } from "@octopus-energy/coral/atoms"
import { useCoralConfig } from "@octopus-energy/coral/providers"
import { token } from "@octopus-energy/coral-design/tokens"
import { css } from "@octopus-energy/coral-design/css"

type Props = PropsWithChildren<
    TypographyProps & {
        showcased?: boolean
    }
>

export function Text({ children, showcased = false, ...props }: Props) {
    const { colorMode } = useCoralConfig();

    return (
        <Typography
            textStyle={showcased ? "h3" : "body1"}
            component="p"
            {...props}
        >
            <span
                data-highlighted={showcased}
                className={css({
                    fontWeight: "bold",
                    lineHeight: 1,
                    _highlighted: {
                        textTransform: "uppercase",
                        color: colorMode === "dark" ? token("colors.contents.actions.success.30") : token('colors.background.actions.success.100'),
                    },
                })}
            >
                {children}
            </span>
        </Typography>
    )
}
